<template>
  <div class='clpp-api-level'>
    <div class='clpp-api-name' :class="{'clpp-api-deprecated': isDeprecated}">
      <span>
        <router-link :to="linkTarget">{{overviewSignature}}</router-link>
      </span>
    </div>
    <div class='clpp-api-level clpp-api-description short-summary' v-html="shortSummary">{{shortSummary}}</div>
  </div>
</template>

<script>
import { DocsComponentMixin } from '../../utils/docs';

export default {
  mixins: [DocsComponentMixin],
  name: 'DocsOverviewEntry'
};
</script>
